import { useQuery } from "@tanstack/react-query";

import { userApi, type User, type UserRoleAssignment } from "@/lib/api/admin-api";
import { EditUserDialog } from "./CreateUserDialog";

interface UserFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  user?: User | null;
}

export function UserFormDialog({ open, onOpenChange, user }: UserFormDialogProps) {
  const userId = user?.id;

  const { data: roleAssignments = [] } = useQuery<UserRoleAssignment[]>({
    queryKey: ["users", userId, "roles", "card-edit"],
    queryFn: () => userApi.getRoles(String(userId)),
    enabled: open && !!userId,
  });

  if (!user) {
    return null;
  }

  return (
    <EditUserDialog
      open={open}
      onOpenChange={onOpenChange}
      user={user}
      roleAssignments={roleAssignments}
    />
  );
}
